<template>
    <div class="">
        <div class="d-flex py-4">
            <div class="icon_menu">
                <v-icon size="48">mdi-cube-outline</v-icon>
            </div>
            <div class="title_menu pl-2">
                <h2>รายการคลังสินค้า</h2>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HeaderStorage"
    }
</script>

<style scoped>

</style>
